import React, { useState, useEffect } from "react";
import Select from "react-select";
import { ErrorMessage, FormikProps } from "formik";

interface CustomSelectLocalProps {
  FormikProps: FormikProps<any>;
  name: string;
  placeholder: string;
  data: any[];
  label?: string;
  onChangeCallback?: (selectedOption: any) => void;
}

const CustomSelectLocal: React.FC<CustomSelectLocalProps> = ({
  FormikProps,
  name,
  placeholder,
  data,
  label,
  onChangeCallback,
}) => {
  const [selected, setSelected] = useState<any>(null);

  useEffect(() => {
    const initialValue = FormikProps.values[name];
    const defaultOption = data.find((item) => item.id === initialValue);

    if (defaultOption) {
      setSelected({
        value: defaultOption.id.toString(),
        label: defaultOption.name,
      });
    }
  }, [FormikProps.values[name], data, name]);

  const handleChange = (selectedOption: any) => {
    FormikProps.setFieldValue(name, selectedOption ? selectedOption.value : "");
    setSelected(selectedOption);
    if (onChangeCallback) {
      onChangeCallback(selectedOption ? selectedOption.value : null);
    }
  };

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      height: "60px",
      borderColor:
        FormikProps?.errors[name] && FormikProps?.touched[name]
          ? "red"
          : FormikProps?.values[name]
          ? "#AFFF6B"
          : "#474A4D",
      "&:hover": {
        borderColor: state.isFocused ? "#AFFF6B" : provided.borderColor,
      },
      backgroundColor: "#474A4D",
      color: selected ? "white" : provided.color,
    }),
    input: (provided: any) => ({
      ...provided,
      color: "#fff",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: selected ? "#fff" : provided.color,
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#fff",
    }),
  };

  const options = data.map((item: any) => ({
    value: item.id.toString(),
    label: item.name,
  }));

  return (
    <div className="w-full mb-4">
      {label && <p className="text-16 text-white mb-2">{label}</p>}
      <Select
        styles={customStyles}
        options={options}
        value={selected}
        onChange={handleChange}
        placeholder={placeholder}
        isClearable
      />
      <ErrorMessage
        name={name}
        component="div"
        className="text-[#F75555]"
      />
    </div>
  );
};

export default CustomSelectLocal;
